import { FC, memo } from "react";
import { ChatServerButton } from "../../xapp/ChatServerMessage";
import { ChatActionButton } from "./ChatActionButton";

export interface ChatActionButtonsProps {
    readonly buttons: readonly ChatServerButton[];
    readonly className?: string;
    onClick(button: ChatServerButton): void;
}

const ChatActionButtonsInner: FC<ChatActionButtonsProps> = (props) => {
    return (
        <div className={"buttons-container " + (props.className || "")}>
            {props.buttons.map((button: ChatServerButton, i: number) => {
                return <ChatActionButton button={button} onClick={props.onClick} key={i} />;
            })}
        </div>
    );
};

export const ChatActionButtons = memo(ChatActionButtonsInner);
